import { GTAG_KEY } from '../config/constants';

export default {
  config: {
    id: GTAG_KEY
  }
};
